"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHREventDrivenClient = void 0;
const eventBus_1 = require("../../../eventBus");
const XHRBase_1 = require("../../../xhr/XHRBase");
const XHRResponse_1 = require("../../../xhr/XHRResponse");
const types_1 = require("../types");
const utils_1 = require("./utils");
class XHREventDrivenClient extends XHRBase_1.XHRBase {
    constructor(eventBus, options) {
        super(options);
        this.eventBus = eventBus;
        this._requests = {};
        this.eventBus.subscribe(types_1.FetchTypeMap.FETCH_RESPONSE, (event) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const id = (_a = event.data) === null || _a === void 0 ? void 0 : _a.id;
            if (id && this._requests[id]) {
                this._requests[id](event);
                this._requests[id] = undefined;
            }
        }));
    }
    sendRequest(method, urlRaw, body, xhrOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const { headers, url } = this.getRequestParams(xhrOptions, urlRaw);
            const responseParams = this.getResponseParams(xhrOptions);
            const [sanitizedHeaders, sanitizedBody] = this.sanitizeHeadersAndBody(headers, body);
            const fetchCall = () => __awaiter(this, void 0, void 0, function* () {
                const pluginResult = yield this.pluginHandleRequest({
                    body: sanitizedBody,
                    headers: sanitizedHeaders,
                    method,
                    mode: 'cors',
                    url,
                });
                const request = yield (0, utils_1.createFetchRequest)(Object.assign({}, pluginResult));
                const fetchEvent = new eventBus_1.EventConfigurable(request);
                return new Promise((resolve, rejects) => {
                    this._requests[request.id] = (_a) => __awaiter(this, [_a], void 0, function* ({ data }) {
                        if (data) {
                            try {
                                const response = yield (0, utils_1.createResponse)(data, url);
                                resolve(response);
                            }
                            catch (e) {
                                rejects(new Error(`Fetch received from Server. Error creating response: ${e.message}`));
                            }
                        }
                        rejects(new Error('Fetch received from Server. No data received'));
                    });
                    this.eventBus.publish(types_1.FetchTypeMap.FETCH, fetchEvent);
                });
            });
            const originCall = () => __awaiter(this, void 0, void 0, function* () {
                try {
                    const response = yield fetchCall();
                    const xhrResponse = yield XHRResponse_1.XHRResponse.create(response, responseParams, {
                        fetchCall,
                        originCall,
                    });
                    return this.makeResponse(xhrResponse);
                }
                catch (e) {
                    throw new Error(`XHR Event Driven Client ${e.message}`);
                }
            });
            return originCall();
        });
    }
    POST(url, body, xhrOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.sendRequest(types_1.RequestMethod.POST, url, body, xhrOptions);
        });
    }
    PUT(url, body, xhrOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.sendRequest(types_1.RequestMethod.PUT, url, body, xhrOptions);
        });
    }
    PATCH(url, body, xhrOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.sendRequest(types_1.RequestMethod.PATCH, url, body, xhrOptions);
        });
    }
    DELETE(url, body, xhrOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.sendRequest(types_1.RequestMethod.DELETE, url, body, xhrOptions);
        });
    }
    GET(urlRaw, xhrOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.sendRequest(types_1.RequestMethod.GET, urlRaw, undefined, xhrOptions);
        });
    }
}
exports.XHREventDrivenClient = XHREventDrivenClient;
//# sourceMappingURL=XHREventDrivenClient.js.map